import { Injectable } from '@angular/core';

import { Query, gql } from 'apollo-angular';

import { CurrencyExchangeRate, QueryCurrencyExchangeRateArgs } from '@hdms/shared/common-types';

export interface CurrencyExchangeRateResponse {
  currencyExchangeRate: CurrencyExchangeRate;
}

@Injectable({
  providedIn: 'root'
})
export class CurrencyExchangeRateGqlService extends Query<CurrencyExchangeRateResponse, QueryCurrencyExchangeRateArgs> {
  override document = gql`
    query CurrencyExchangeRate($currencyFrom: String!, $currencyTo: String!) {
      currencyExchangeRate(currencyFrom: $currencyFrom, currencyTo: $currencyTo) {
        exchangeRateFrom
        exchangeRateTo
      }
    }
  `;
}
